import sanitizeHtml from 'sanitize-html';

export default function sanitizeObject(obj, propertyName) {
  const unitEx = /^\d+(?:px|em|rem|%)$/; // Match any number with px, em, rem, or %

  Object.entries(obj).forEach(([prop, value]) => {
    if (typeof value === 'string') {
      if (!propertyName || prop === propertyName) {
        obj[prop] = sanitizeHtml(value, {
          allowedTags: sanitizeHtml.defaults.allowedTags.concat('span'),
          allowedAttributes: {
            '*': ['style'],
            a: sanitizeHtml.defaults.allowedAttributes.a.concat('style'),
            img: sanitizeHtml.defaults.allowedAttributes.img,
          },
          allowedStyles: {
            '*': {
              // Match HEX and RGBA
              color: [/^#(0x)?[0-9a-f]+$/i, /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
              'text-align': [/^left$/, /^right$/, /^center$/],
              'font-size': [unitEx],
              'font-weight': [/^lighter$/, /^normal$/, /^bold$/, /^bolder$/],
              'font-style': [/^normal$/, /^italic$/, /^oblique$/],
              // Match HEX and RGBA
              'background-color': [/^#(0x)?[0-9a-f]+$/i, /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/],
              padding: [unitEx],
              margin: [unitEx],
              'text-decoration': [/^none$/, /^underline$/, /^line-through$/, /^overline$/],
              'text-transform': [/^capitalize$/, /^lowercase$/, /^uppercase$/],
            },
          },
        });
      }
      return;
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      obj[prop] = sanitizeObject(value, propertyName);
    }
  });

  return obj;
}
